var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"root",attrs:{"tag":"div","name":"entry"}},_vm._l((_vm.entries),function(entry){return _c('div',{key:entry.id,staticClass:"textContainer"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(entry.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }